import React from 'react';
import { cx } from '../../../utils/cx';
import { formatPrice } from '../../../utils/format-number';
import { translate } from '../../../utils/wp.js';

export function HotelPackageTag({
    price,
    includedPrice,
    available,
}) {
    let text = '';

    text = '+' + formatPrice(price - includedPrice) + ' SEK / person';

    if (
        NOJESRESOR_PRODUCT.hotels.optional
        || NOJESRESOR_PRODUCT.hotels.without
    ) {
        text = formatPrice(price - includedPrice) + ' SEK / person';
    }

    if (
        price - includedPrice === 0
        && !NOJESRESOR_PRODUCT.hotels.optional
    ) {
        text = translate('included_in_package');
    }

    if (!available) {
        text = translate('fully_booked');
    }

    return (
        <div
            className={cx(
                'px-1.5 rounded-sm font-semibold text-[12px] leading-[20px]',
                price - includedPrice === 0
                    ? 'text-green text-xs'
                    : 'bg-[#EBEBEB]',
                !available && 'bg-red !text-black',
            )}
        >
            {text}
        </div>
    );
}
